module.exports = __webpack_public_path__ + "static/media/sale-mobile.4dd582ce.png";